import { toast } from 'react-toastify';
import * as yup from 'yup';

import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import {
  formatDate,
  getIdsPaging,
  getPermissionRestaurant,
  downloadFileExport,
  isSuccess,
} from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { trans } from '../../../localization/index';
import {
  EnumMerchantPermission,
  EnumMerchantPaidMethod,
} from '../../../constants/enum';
import { MAX_LENGTH_IDS_REQUEST } from '../../../constants/constants';

export function receiveTransactionReportRestaurant(itemList) {
  return {
    type: actions.RECEIVE_TRANSACTION_REPORT_RESTAURANT,
    response: {
      itemList,
    },
  };
}

export function handleChangeFiltersTransaction(name, value) {
  return {
    type: actions.CHANGE_FILTER_TRANSACTION,
    response: {
      [name]: value,
    },
  };
}

export function getListReportRestaurantInfo(ids) {
  function validate(state, dispatchGeneralError) {
    const { filters } = state;
    const schema = yup.object().shape({
      fromDate: yup
        .date()
        .max(yup.ref('toDate'), trans('from_date_to_date_not_correct'))
        .required(),
      toDate: yup.date().required(),
      restaurant: yup.object().shape({
        value: yup.number().required(),
      }),
    });
    try {
      schema.validateSync(filters);
      return true;
    } catch (err) {
      dispatchGeneralError(err.errors[0]);
      return false;
    }
  }

  function genBody(state) {
    const { filters, table } = state;
    const { itemList } = table;
    const { fromDate, toDate, restaurant } = filters;

    const body = {
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
    };

    if (restaurant.value) {
      body.restaurant_ids = [restaurant.value];
    } else {
      body.restaurant_ids = itemList;
    }

    return body;
  }

  return (dispatch, getState) => {
    if (ids && ids.length === 0) {
      return Promise.resolve({});
    }
    const state = getState().report.restaurant;
    if (!validate(state, error => dispatch(setGeneralError(error)))) {
      return null;
    }
    const body = genBody(state);
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/report/get_by_restaurant_v3', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { restaurant_reports: restaurantReports = [] } = response.reply;
          const itemData = restaurantReports.reduce(
            (map, item) => ({ ...map, [item.id]: item }),
            {},
          );
          dispatch({
            type: actions.RECEIVE_LIST_REPORT_RESTAURANT_INFO,
            response: {
              itemData,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function getShowTotalReportRestaurant(listIdLoaded = []) {
  return (dispatch, getState) => {
    const { report } = getState();
    const { table } = report.restaurant;
    const { itemData, itemList } = table;
    const dataExists = Object.keys(itemData).map(Number);
    const idsLoad = itemList.filter(
      m => !dataExists.includes(m) && !listIdLoaded.includes(m),
    );

    const totalIdsLoad = idsLoad.length;
    if (totalIdsLoad > 0) {
      for (let i = 0; i < totalIdsLoad; i += MAX_LENGTH_IDS_REQUEST) {
        const ids = idsLoad.slice(i, i + MAX_LENGTH_IDS_REQUEST);
        dispatch(getListReportRestaurantInfo(ids));
      }
    }
  };
}

export function getListReportRestaurantIds() {
  return (dispatch, getState) => {
    const { app, report } = getState();
    const { filters, table } = report.restaurant;
    const { pageSize } = table;
    const { restaurant, isShowTotal } = filters;
    const { restaurants } = app;
    let itemList = [];
    if (restaurant.value > 0) {
      itemList = [restaurant.value];
    } else {
      itemList = getPermissionRestaurant(
        restaurants,
        EnumMerchantPermission.REPORT_ALL.id,
      ).map(restaurantItem => restaurantItem.restaurant_id);
    }
    dispatch({
      type: actions.RECEIVE_LIST_REPORT_RESTAURANT_IDS,
      response: {
        itemList,
      },
    });

    const ids = getIdsPaging(itemList, 1, pageSize);
    dispatch(getListReportRestaurantInfo(ids));
    if (isShowTotal) {
      dispatch(getShowTotalReportRestaurant(ids));
    }
  };
}

export function getTransactionAirpay() {
  function genBody(state) {
    const { filters } = state;
    const {
      restaurant, fromDate, toDate, transactionStatus,
    } = filters;

    const body = {
      restaurant_id: restaurant.restaurantId,
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
      status: transactionStatus,
    };
    return body;
  }

  return (dispatch, getState) => {
    const { dialog } = getState().report.restaurant;
    const body = genBody(dialog);
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/report/get_airpay_transactions', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { transactions: itemList } = response.reply;
          dispatch(receiveTransactionReportRestaurant(itemList));
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function getTransactionCod() {
  function genBody(state) {
    const { filters } = state;
    const {
      restaurant, fromDate, toDate, transactionStatus,
    } = filters;

    const body = {
      restaurant_id: restaurant.restaurantId,
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
      transaction_status: transactionStatus,
    };
    return body;
  }

  return (dispatch, getState) => {
    const { dialog } = getState().report.restaurant;
    const body = genBody(dialog);
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/report/get_cod_transactions', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { transactions: itemList } = response.reply;
          dispatch(receiveTransactionReportRestaurant(itemList));
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function getTransaction() {
  return (dispatch, getState) => {
    const { filters } = getState().report.restaurant.dialog;
    const { merchantPaidMethod } = filters;
    switch (merchantPaidMethod) {
      case EnumMerchantPaidMethod.COD.id: {
        dispatch(getTransactionCod());
        break;
      }
      case EnumMerchantPaidMethod.TOPPAY.id: {
        dispatch(getTransactionAirpay());
        break;
      }
      default: {
        break;
      }
    }
  };
}

export function openTransactionRestaurantReport(
  restaurant,
  merchantPaidMethod,
) {
  return (dispatch, getState) => {
    const { filters } = getState().report.restaurant;
    const { fromDate, toDate } = filters;
    const filterReport = {
      restaurant,
      fromDate,
      toDate,
      merchantPaidMethod,
    };
    dispatch({
      type: actions.OPEN_TRANSACTION_REPORT_RESTAURANT,
      response: {
        filters: filterReport,
      },
    });

    dispatch(getTransaction());
  };
}

export function changeTableActivePageTransaction(activePage) {
  return {
    type: actions.CHANGE_TABLE_ACTIVE_PAGE_TRANSACTION,
    response: {
      activePage,
    },
  };
}

export function changeTablePageSizeTransaction(pageSize) {
  return {
    type: actions.CHANGE_TABLE_PAGE_SIZE_TRANSACTION,
    response: {
      pageSize,
    },
  };
}

export function exportRestaurantReport() {
  function genBody(state) {
    const { filters } = state;
    const { fromDate, toDate, restaurant } = filters;

    const body = {
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
    };
    if (restaurant.value > 0) {
      body.restaurant_ids = [restaurant.value];
    }
    return body;
  }
  return (dispatch, getState) => {
    const state = getState().report.restaurant;
    const body = genBody(state);
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/report/export_restaurant_report', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { file_url: fileUrl } = response.reply;
          downloadFileExport(fileUrl);
          toast.success(trans('mod_export_success'));
        }
        dispatch(stopAppLoading());
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/actions.js